function translateDigit(digit) {
    switch (digit) {
        case 0:
            return '';
        case 1:
            return '一';
        case 2:
            return '二';
        case 3:
            return '三';
        case 4:
            return '四';
        case 5:
            return '五';
        case 6:
            return '六';
        case 7:
            return '七';
        case 8:
            return '八';
        case 9:
            return '九';
        default:
            return digit.toString();
    }
}
function digitWithPrefix(prefix, digit) {
    switch (digit) {
        case 0:
            return '';
        case 1:
            return prefix;
        default:
            return `${translateDigit(digit)}${prefix}`;
    }
}
class GmwTranslateNumber {
    static factory() {
        const factoryFunction = () => {
            return (input) => {
                if (input === undefined) {
                    return undefined;
                }
                if (process.env.LANGUAGE === 'zh-CN') {
                    const thousands = Math.floor(input / 1000);
                    const hundreds = Math.floor((input % 1000) / 100);
                    const tens = Math.floor((input % 100) / 10);
                    const units = Math.floor(input % 10);
                    return `${digitWithPrefix('千', thousands)}${digitWithPrefix('百', hundreds)}${digitWithPrefix('十', tens)}${translateDigit(units)}`;
                }
                return input.toString();
            };
        };
        return factoryFunction;
    }
}
export default angular
    .module('gm.wealth.common')
    .filter('gmwTranslateNumber', GmwTranslateNumber.factory()).name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/translate-number.ts